import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/*global google*/
import React, { memo, useRef, useState, useCallback, useEffect, useMemo } from 'react';
import MapRender from './Map';
import StoreSearch from './StoreSearch';
import { isEqual } from 'lodash';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import defaultClasses from './storeLocator.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { fetchGeoLocation } from '../FetchGeoLocation';

function showPosition(setcurrentPosition) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      setcurrentPosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  } else {
    return null;
  }
}

var StoreLocator = memo(function (props) {
  var classes = useStyle(defaultClasses, props.classes);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentPosition = _useState2[0],
      setcurrentPosition = _useState2[1];

  useEffect(function () {
    showPosition(setcurrentPosition);
  }, []);
  var predefinedCoordinates = {
    lat: currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.lat,
    lng: currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.lng
  };
  var getZoomValue = useCallback(function (radius) {
    if (radius === '25') {
      return 10;
    } else if (radius === '50') {
      return 9.5;
    } else if (radius === '100') {
      return 9;
    } else if (radius === '150') {
      return 8.5;
    }

    return 10;
  }, []);

  var _useState3 = useState({
    label: '25 miles',
    value: '25',
    zoom: 3
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      radius = _useState4[0],
      setRadius = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showMarker = _useState6[0],
      setShowMarker = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMarkerShown = _useState8[0],
      setIsMarkerShown = _useState8[1];

  var defaultShownStores = {};

  if (props.stores) {
    props.stores.map(function (store) {
      defaultShownStores[store.store_id] = false;
      return store;
    });
  }

  var _useState9 = useState(defaultShownStores),
      _useState10 = _slicedToArray(_useState9, 2),
      shownStores = _useState10[0],
      setShownStores = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      geoError = _useState12[0],
      setGeoError = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      address = _useState14[0],
      setAddress = _useState14[1];

  var getGeolocation = function getGeolocation(optionalFn) {
    navigator.geolocation.getCurrentPosition(function (position) {
      if (optionalFn) {
        optionalFn();
      } // setShowOptions(false);


      fetchGeoLocation(position, setAddress);
      setCoordinates({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
      findRetail(position.coords.latitude, position.coords.longitude, radius === '' ? '100' : radius === null || radius === void 0 ? void 0 : radius.value); // setUserLocation(true);

      setIsMarkerShown(true);
    }, function (error) {
      setGeoError(true); // setUserLocation(false);
    }, {
      enableHighAccuracy: true,
      timeout: 5 * 1000,
      // 5 seconds
      maximumAge: 0
    });
  };

  useEffect(function () {
    getGeolocation();
  }, []);
  useEffect(function () {
    setGeoError(false);
  }, [address]); // state for showing/hiding 'Reset Search' button

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showResetSearch = _useState16[0],
      setShowResetSearch = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showSearchResults = _useState18[0],
      setShowSearchResults = _useState18[1];

  var _useState19 = useState({
    lat: currentPosition !== null && currentPosition !== void 0 && currentPosition.lat ? currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.lat : 37.0902,
    lng: currentPosition !== null && currentPosition !== void 0 && currentPosition.lng ? currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.lng : -95.7129,
    radius: 3
  }),
      _useState20 = _slicedToArray(_useState19, 2),
      newPosition = _useState20[0],
      setNewPosition = _useState20[1];

  var onGetDirection = function onGetDirection(lat, lng, radius) {
    setNewPosition({
      lat: lat,
      lng: lng,
      radius: radius
    });
  };

  var _useState21 = useState(props.stores),
      _useState22 = _slicedToArray(_useState21, 2),
      storesNearby = _useState22[0],
      setStoresNearby = _useState22[1];

  var _useState23 = useState({
    lat: '',
    lng: ''
  }),
      _useState24 = _slicedToArray(_useState23, 2),
      coordinates = _useState24[0],
      setCoordinates = _useState24[1]; // const [zipCode, setZipCode] = useState('');
  // const [countryShortName, setCountryShortName] = useState('');
  // const [countryLongName, setCountryLongName] = useState('');
  // const [userLocation, setUserLocation] = useState(undefined);


  var getDistance = useCallback(function (lat1, lng1, lat2, lng2) {
    var distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(lat1, lng1), new google.maps.LatLng(lat2, lng2));
    return distance / 1000 / 1.609;
  }, []);
  var resetSearch = useCallback(function () {
    var resetRadiusCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    setAddress('');
    setCoordinates(predefinedCoordinates);
    setShowMarker(false);
    setRadius({
      label: '25 miles',
      value: '25',
      zoom: 3
    });
    setStoresNearby(props.stores);
    setIsMarkerShown(false);
    setShowResetSearch(false);
    setShowSearchResults(false);

    if (typeof resetRadiusCallback === 'function') {
      resetRadiusCallback();
    }
  }, [predefinedCoordinates, props.stores, address]); // const predefinedHandler = async () => {
  //     const results = await geocodeByAddress(sugg[0].description);
  //     const latLng = await getLatLng(results[0]);
  //     console.log(results);
  //     setCoordinates(latLng);
  //     setNewPosition(latLng);
  // };

  var handleSelect = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, radius) {
      var results, latLng;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return geocodeByAddress(value);

            case 2:
              results = _context.sent;
              _context.next = 5;
              return getLatLng(results[0]);

            case 5:
              latLng = _context.sent;
              setCoordinates(latLng);
              setNewPosition(latLng);
              setAddress(value);
              setIsMarkerShown(true);
              setShowResetSearch(true);
              setShowSearchResults(true);

              if (props.stores) {
                findRetail(latLng.lat, latLng.lng, radius === null || radius === void 0 ? void 0 : radius.value);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [props.stores]);
  var findRetail = useCallback(function (lat, lng, radius) {
    var _props$stores;

    var radiusValue = radius ? Number(radius) : 25;
    setStoresNearby(_toConsumableArray((_props$stores = props.stores) === null || _props$stores === void 0 ? void 0 : _props$stores.filter(function (store) {
      var distance = getDistance(lat, lng, store.lat, store.lng);
      return distance <= radiusValue;
    }).map(function (store) {
      var distance = getDistance(lat, lng, store.lat, store.lng);
      return _objectSpread(_objectSpread({}, store), {}, {
        distance: distance
      });
    })).sort(function (a, b) {
      return a.distance - b.distance;
    }));
    setNewPosition({
      lat: lat,
      lng: lng,
      radius: radius ? radius : 25
    });
    setRadius({
      value: radiusValue,
      zoom: getZoomValue(radius || 25),
      label: radiusValue + ' miles'
    });
    setShowMarker(true);
  }, [getDistance, props.stores]);
  var handleChange = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var value, zoom;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              value = e !== null && e !== void 0 && e.target ? e.target.value : e === null || e === void 0 ? void 0 : e.value;
              zoom = getZoomValue(value);
              setRadius({
                value: value,
                zoom: zoom
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [address, setRadius, newPosition, findRetail]);

  var _useState25 = useState(true),
      _useState26 = _slicedToArray(_useState25, 2),
      viewAll = _useState26[0],
      setViewAll = _useState26[1];

  var toggle = function toggle() {
    setViewAll(!viewAll);
  }; // setting coordinates values


  useEffect(function () {
    if (predefinedCoordinates && (predefinedCoordinates === null || predefinedCoordinates === void 0 ? void 0 : predefinedCoordinates.lat) !== undefined && coordinates.lat === undefined && coordinates.lng === undefined) {
      setCoordinates(predefinedCoordinates);
    }
  }, [predefinedCoordinates, coordinates === null || coordinates === void 0 ? void 0 : coordinates.lat, coordinates === null || coordinates === void 0 ? void 0 : coordinates.lng]);
  var mapRef = useRef(null);

  var scrollToMap = function scrollToMap(event) {
    event.preventDefault();
    mapRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start'
    });
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(StoreSearch, {
    onGetDirection: onGetDirection,
    predefinedCoordinates: predefinedCoordinates,
    address: address,
    setAddress: setAddress,
    handleSelect: handleSelect,
    setCoordinates: setCoordinates,
    setIsMarkerShown: setIsMarkerShown,
    findRetail: findRetail,
    radius: radius // setUserLocation={setUserLocation}
    ,
    handleChange: handleChange,
    coordinates: coordinates,
    newPosition: newPosition,
    setNewPosition: setNewPosition,
    showMarker: showMarker,
    storesNearby: storesNearby // isMarkerShown={isMarkerShown}
    ,
    shownStores: shownStores,
    setShownStores: setShownStores,
    viewAll: viewAll,
    toggle: toggle // e_commerce={props.e_commerce}
    ,
    resetSearch: resetSearch,
    showResetSearch: showResetSearch,
    setShowResetSearch: setShowResetSearch,
    getGeolocation: getGeolocation,
    geoError: geoError,
    classes: {
      root: classes.pdpSearch
    },
    scrollToMap: scrollToMap,
    showSearchResults: showSearchResults
  }), !props.hideGoogleMaps && React.createElement("div", {
    id: "map-local",
    ref: mapRef,
    className: "".concat(classes.googleMapWrapper, " w-full")
  }, React.createElement(MapRender, {
    coordinates: coordinates,
    newPosition: newPosition,
    setNewPosition: setNewPosition,
    showMarker: showMarker,
    radius: radius,
    isMarkerShown: isMarkerShown,
    storesNearby: storesNearby,
    shownStores: shownStores,
    setShownStores: setShownStores
  })));
}, function (prevProps, nextProps) {
  if (isEqual(prevProps, nextProps)) {
    return true;
  }

  return false;
});
export default StoreLocator;